import { Injectable } from '@angular/core';
import { NotificationService, NotificationSettings } from '@progress/kendo-angular-notification';

@Injectable({
  providedIn: 'root'
})
export class NotificationPopupService {
  constructor(private notificationService: NotificationService) { }

  showNotification(message: string, type: 'success' | 'info' | 'warning' | 'error'): void {
    const settings: NotificationSettings = {
      content: message
      , animation: { type: 'slide', duration: 400 }
      , position: { horizontal: 'right', vertical: 'bottom' }
      , type: { style: type, icon: true }
    };

    this.notificationService.show(settings);
  }
}
